<template>
  <div class="lg:text-3xl text-xl font-semibold mb-4 flex items-center">
    <Button
        v-if="showButton"
        class="mr-4 text-[#0f172a] dark:text-white bg-white border-[#e2e8f0] hover:bg-[#f1f5f9] dark:bg-zinc-700 dark:hover:bg-zinc-600 active:bg-[#e2e8f0] border dark:border-0"
        icon="fas fa-arrow-left"
        rounded
        :aria-label="$t('label.return')"
        severity="secondary"
        @click="goBack"
    />
    <slot name="title">{{ $t('title.default') }}</slot>
  </div>
</template>

<script>
export default {
  props: {
    showButton: {
      type: Boolean,
      default: true
    },
  },

  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);

        return;
      }

      this.$router.push('/');
    }
  }
};
</script>
